<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="states" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">States</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add State" icon="pi pi-plus" @click="toAddState" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" 
                                class="p-mr-2" style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Country" field="maj2" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="State" field="mak3" class="p-text-capitalize" headerStyle="width: 35%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.mak5 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.mak5 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editStateModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add State">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="country">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="country" v-model="country" :options="countries" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.country.$error">{{ v$.country.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            State
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="100" placeholder="Enter State" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="statecode">State Code</label>
                        <InputText id="statecode" v-model="statecode" required="true" maxlength="100" placeholder="Enter State Code" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addstate" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit State" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="country">
                            Country
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="country" v-model="country" :options="countries" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.country.$error">{{ v$.country.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            State
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="100" placeholder="Enter State" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="statecode">State Code</label>
                        <InputText id="statecode" v-model="statecode" required="true" maxlength="30" placeholder="Enter State Code" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body"></Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editState(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
    <!-- confirmation modal start here -->
    <ConfirmDialog group="positioned"></ConfirmDialog>
    <!-- confirmation modal end here -->

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="State Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="statefilter"> State</label>
                    <Dropdown id="statefilter" v-model="stateFilter" :options="stateFilterList" optionLabel="label"
                    placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            states: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            country: '',
            statecode: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            stateFilter: '',
            stateFilterList : [],
        };
    },
    validations() {
        return {
            reportreason: { required: helpers.withMessage('Please enter State', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            country: { required: helpers.withMessage('Please select country', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getAllStates({ page_no: this.page_no });
        this.getCountries();
    },
    methods: {
        getCountries() {
            this.ApiService.getCountries().then((items) => {
                if (items.status === 200) {
                    this.countries = items.data;
                }
            })
        },
        getAllStates(e) {
            e.page_no = this.page_no;
            this.ApiService.getAllStates(e).then((items) => {
                if (items.status === 200) {
                    this.states = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.states = [];
                }
                this.loading = false;
            });
        },
        async toAddState() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.reportreason = '';
            this.statecode = '';
            this.country = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addstate() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('mak2', this.country.value);
            formData.append('mak3', this.reportreason);
            formData.append('mak4', this.statecode);
            formData.append('mak5', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateStates(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllStates({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editStateModalOpen(data) {
            this.isEditUserRole = true;
            this.reportreason = '';
            this.adminstatus = '',
            this.rowId = data.mak1;
            this.reportreason = data.mak3;
            this.statecode = data.mak4;
            this.country = this.countries.find((item) => item.value == data.maj1);
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.mak5);
        },
        editState() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mak1', this.rowId);
            formData.append('mak2', this.country.value);
            formData.append('mak3', this.reportreason);
            formData.append('mak4', this.statecode);
            formData.append('mak5', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateStates(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllStates({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAllStates({ page_no: event.page });
        },
        getStates() {
            this.ApiService.getStates().then((items) => {
                if (items.status === 200) {
                    this.stateFilterList = items.data;
                }
            })
        },
        reSetFilteredData() {
            this.getAllStates({ page_no: this.page_no });
            this.isFilter = false;
            this.stateFilter = '';
            this.stateFilter = '';
            this.adminstatus = { label: 'Active', value: 1 };
            // this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
            this.getStates();
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getAllStates({ mak3: this.stateFilter.label, mak5: this.adminstatus.value, page_no: this.page_no });
        },
    }
};
</script>